var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "ob1-popin-modal2",
        {
          attrs: {
            id: _vm.modalId,
            "aria-labelledby": _vm.modalId + "-details",
            "show-close-button":
              !_vm.recoverySimulator || !_vm.simulatorModalId,
          },
        },
        [
          _c("h3", { staticClass: "h4 my-1" }, [
            _vm._v(
              "\n            " + _vm._s(_vm.infosRecovery.title) + "\n        "
            ),
          ]),
          _vm._v(" "),
          _vm.bonusAmount
            ? _c("ob1-message-complementaire", {
                staticClass: "text-mw mb-2",
                attrs: { title: _vm.bonusAmount + _vm.infosRecovery.message },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("ul", { staticClass: "list-unstyled mb-0" }, [
            _c("li", { staticClass: "text-mw mb-1" }, [
              _c("div", { staticClass: "items-list-item highlight" }, [
                _c("span", {
                  staticClass: "item-icon",
                  class: _vm.infosRecovery.stepOne.icon,
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" "),
                _c("p", {
                  staticClass: "mb-0",
                  domProps: {
                    innerHTML: _vm._s(_vm.infosRecovery.stepOne.text),
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "text-mw" },
              [
                _c("div", { staticClass: "items-list-item highlight" }, [
                  _c("span", {
                    staticClass: "item-icon",
                    class: _vm.infosRecovery.stepTwo.icon,
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "mb-0",
                    domProps: {
                      innerHTML: _vm._s(_vm.infosRecovery.stepTwo.text),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("AlertMessage", {
                  staticClass: "mt-1",
                  attrs: {
                    type: "warning",
                    "is-mini": "",
                    title: _vm.infosRecovery.warningMessage,
                    "bold-title": false,
                  },
                }),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "list-unstyled mt-1" },
                  _vm._l(
                    _vm.infosRecovery.processDetails,
                    function (item, index) {
                      return _c(
                        "li",
                        {
                          key: "process-item-" + index,
                          staticClass: "text-mw",
                          class:
                            index ===
                            _vm.infosRecovery.processDetails.length - 1
                              ? ""
                              : "mb-1",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "items-list-item highlight" },
                            [
                              _c("span", {
                                staticClass: "item-icon",
                                class: item.icon,
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(" "),
                              _c("p", {
                                staticClass: "mb-0",
                                domProps: { innerHTML: _vm._s(item.text) },
                              }),
                            ]
                          ),
                        ]
                      )
                    }
                  ),
                  0
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.recoverySimulator.bonASavoirText
            ? _c("AlertMessage", {
                attrs: {
                  title: _vm.recoverySimulator.bonASavoirText,
                  "no-background": true,
                  "bold-title": false,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "ob1-liens-haut-bas",
            {
              attrs: {
                "button-id": "recovery-more-button",
                "button-label": _vm.moreLabel,
                "collapsed-block-id": "recovery-more-infos",
                "is-collapsed": true,
              },
            },
            [
              _vm.onlineRecovery
                ? _c("recovery-details-part", {
                    staticClass: "mb-1",
                    attrs: { "recovery-details": _vm.onlineRecovery },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.storeRecovery
                ? _c("recovery-details-part", {
                    attrs: { "recovery-details": _vm.storeRecovery },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.bonus
                ? [
                    _c("h4", { staticClass: "mt-1" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.bonusRecovery.title) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("recovery-bonus-part", {
                      attrs: {
                        "bonus-details": _vm.bonusRecovery,
                        condition: _vm.bonus.condition,
                      },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm.recoverySimulator && _vm.simulatorModalId
            ? _c(
                "div",
                { staticClass: "modal-footer mt-2" },
                [
                  _c("ob1-boutons", {
                    attrs: {
                      "is-primary": true,
                      label: _vm.simulatorButtonLabel,
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#" + _vm.simulatorModalId,
                      "data-oevent-label": "estimer_votre_mobile_actuel",
                      "data-oevent-action": "j_accede_au_simulateur",
                      "data-oevent-category":
                        "estimer_votre_appareil_depuis_la_popin_de_reprise",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }